import { type ValoriSezione } from '@framework/api-client/api/inquiries-compile/schemas/valoriSezione.ts';
import { type IEngineSection } from '@framework/engine/schema/sections/IEngineSection.ts';
import { type YupAnyObjectSchema } from '@framework/validation/YupObjectSchema.ts';
import { type ModuleFormSource } from './ModuleFormSource.ts';
import { ReadonlySharedSectionForm } from './shared-section/ReadonlySharedSectionForm.tsx';
import { SharedSectionWrapper } from './shared-section/SharedSectionWrapper.tsx';
import { useSharedSectionSourceHref } from './shared-section/useSharedSectionSourceHref.ts';

/**
 * Componente dedicato per le sezioni condivise esterne (readonly).
 * Estratto per poter utilizzare l'hook `useSharedSectionSourceHref`
 * che richiede di essere chiamato al top-level di un componente.
 */
export function ExternalSharedSection(props: {
  section: IEngineSection;
  moduleSchema: YupAnyObjectSchema;
  moduleValues: ValoriSezione[];
  moduleFormSource: ModuleFormSource;
}) {
  const { section, moduleSchema, moduleValues, moduleFormSource } = props;
  const sourceModuleId =
    section.shared?.type === 'external' ? section.shared.moduleId : null;
  const sourceHref = useSharedSectionSourceHref(
    sourceModuleId,
    moduleFormSource,
  );

  return (
    <SharedSectionWrapper mode="readonly" sourceHref={sourceHref}>
      <ReadonlySharedSectionForm
        section={section}
        moduleSchema={moduleSchema}
        moduleValues={moduleValues}
      />
    </SharedSectionWrapper>
  );
}
